import { render, staticRenderFns } from "./WebTopBar.vue?vue&type=template&id=65ef466d&"
import script from "./WebTopBar.vue?vue&type=script&lang=js&"
export * from "./WebTopBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports